var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenericTrainerphoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#E5E5E5",
    d: "M44.629 47.999H3.262c-1.575 0-2.853-.793-2.853-2.389 0-.181.024-5.055 2.1-9.264 1.65-3.349 6.442-4.816 12.937-7.226.378-.141 1.66-.158 1.66-.304v-2.619c-2.993-1.02-2.332-2.724-2.623-5.149-.392-.536-.969-1.234-1.177-2.122-.397-1.706-.308-3.336.402-4.585-.717-2.466-1.714-6.386.25-9.07a5.063 5.063 0 0 1 2.87-1.963C18.358 1.494 21.304.46 25.196.46c4.544 0 9.694 1.542 10.547 5.867.565 2.863-.563 6.128-1.348 8.166.643 1.227.824 2.796.444 4.433-.207.887-.394 1.585-.787 2.12-.294 2.499-1.982 4.32-1.982 5.379v2.391c0 .146.636.289 1.015.429 6.493 2.409 10.714 4.003 12.367 7.352 2.075 4.21 2.065 8.832 2.065 9.013 0 1.596-1.312 2.389-2.888 2.389z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericTrainerphoto);
export default __webpack_public_path__ + "static/media/generic-trainerphoto.981cc153c17c220dc74eee3e48380b95.svg";
export { ForwardRef as ReactComponent };